import I18n from 'I18n';
// @ts-expect-error untyped import
import { isCustomObjectType } from 'reporting-data/lib/customObjects';
// @ts-expect-error untyped import
import { getObjectTypeFamily } from '../modify/filters/xo-filter-utils';
import { hasObjectTypeId } from './source-utils';
import { EventDateInterval } from '../schema/filter-records';
import { getIsUngated } from '../../shared/lib/utils';
import { MIGRATE_LEGACY_ILS_DATE_TIME_FILTERS, SNOWFLAKE_PROPERTY_FILTER_GATE } from 'reporting-data/constants/gates';
//@ts-expect-error untyped import
import { isIdProperty } from '../metadata/references/object/object-mapping';
import { isTableEventLike } from './table-utils';
const createDefaultEventDateTimepoint = () => {
  const zoneId = I18n.moment.portalTz().tz() || 'UTC';
  return EventDateInterval({
    propertyFilterOperation: {
      propertyParser: 'VALUE',
      propertyType: 'rangedtime',
      operator: 'IS_BETWEEN',
      lowerBoundTimePoint: {
        timeType: 'INDEXED',
        indexReference: {
          referenceType: 'TODAY'
        },
        offset: {
          days: -31
        },
        zoneId
      },
      upperBoundTimePoint: {
        timeType: 'INDEXED',
        indexReference: {
          referenceType: 'NOW'
        },
        zoneId
      },
      lowerBoundEndpointBehavior: 'INCLUSIVE',
      upperBoundEndpointBehavior: 'INCLUSIVE'
    }
  });
};
export const createDefaultEventDateInterval = userGates => {
  if (userGates && getIsUngated(SNOWFLAKE_PROPERTY_FILTER_GATE, userGates) && getIsUngated(MIGRATE_LEGACY_ILS_DATE_TIME_FILTERS, userGates)) {
    return createDefaultEventDateTimepoint();
  }
  return EventDateInterval({
    propertyFilterOperation: {
      defaultValue: null,
      includeObjectsWithNoValueSet: false,
      numberOfDays: 31,
      operator: 'IS_LESS_THAN_X_DAYS_AGO',
      propertyType: 'datetime-rolling'
    }
  });
};
export const getFilterFamily = source => hasObjectTypeId(source) && !isCustomObjectType(source.objectTypeId) ? getObjectTypeFamily(source.objectTypeId) : source.dataSourceId;
export const transformToFilterBranch = (filter, property) => {
  const propertyFilter = filter.filter;
  const filters = propertyFilter.get('operation') ? [{
    filterType: 'PROPERTY',
    operation: propertyFilter.get('operation').toJS(),
    property
  }] : [];
  const filterBranch = {
    filterBranches: [{
      filterBranches: [],
      filterBranchOperator: 'AND',
      filterBranchType: 'AND',
      filters
    }],
    filterBranchOperator: 'OR',
    filterBranchType: 'OR',
    filters: []
  };
  return filterBranch;
};
export const getIsUngatedToSnowflakePropertyFilterMigration = userGates => {
  return getIsUngated(SNOWFLAKE_PROPERTY_FILTER_GATE, userGates);
};
export const getReportingFilterContext = (source, property) => {
  return isTableEventLike(source) ? 'snowflake_event' : isIdProperty(property.name, source.objectTypeId) ? 'snowflake_id' : 'snowflake_object';
};